<template>
  <main id="admin-user-group-main">
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('admin.userGroups.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" @search-performed="val => isShipper = val"/>
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" class="default-section-title">
              {{ $t('admin.userGroups.summaryTitle') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button" @click="handleRefresh" />
              </el-tooltip>
            </el-col>
            <el-col :span="18" class="default-section-actions text-align-end">
              <GenerateInvitation />
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary @refresh-and-clear="handleResetSearch" :is-shipper="isShipper"/>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';
import GenerateInvitation from './components/GenerateInvitation';

export default {
  name: 'userGroups',
  components: {
    SearchFilter,
    SearchSummary,
    GenerateInvitation
  },
  data() {
    return {
      isShipper: false
    };
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    },
    handleResetSearch() {
      if (this.$refs.searchFilter) {
        this.$refs.searchFilter.resetAndSearch();
      }
    }
  }
};
</script>
